import Vue from "vue";
import Vuex from "vuex";
// import createLogger from 'vuex/dist/logger'

import ImsUsers from "./modules/ImsUsers";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    modules: {
        ImsUsers
    },
    strict: debug,
    // plugins: debug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/store/index.js